/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ticket-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M19.5 12.25h0a3.74 3.74 0 013.12-3.71h-.01c.36-.07.62-.38.62-.74V5.47c0-.83-.68-1.5-1.5-1.5H2.22c-.83 0-1.5.67-1.5 1.5 0 0 0 0 0 0v2.31H.71c-.01.36.26.67.62.73h0c2.04.34 3.42 2.27 3.08 4.31a3.76 3.76 0 01-3.09 3.08h-.01a.74.74 0 00-.63.73v2.3h0c0 .82.67 1.49 1.5 1.49h19.5-.01c.82 0 1.5-.68 1.5-1.5V16.59c0-.37-.27-.68-.63-.74l-.01-.01a3.756 3.756 0 01-3.13-3.7zM15.75 17.5V16M15.75 13v-1.5M15.75 8.5V7M8.25 17.5V16M8.25 13v-1.5M8.25 8.5V7"/></g>'
  }
})
